import { render, staticRenderFns } from "./VideoText.vue?vue&type=template&id=20b43247&"
import script from "./VideoText.vue?vue&type=script&lang=js&"
export * from "./VideoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports